import { css } from '@emotion/react';

const tooltipCss = css`
  .rc-tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    visibility: visible;
    font-size: 12px;
    line-height: 1.5;
    opacity: 0.9;

    &-hidden {
      display: none;
    }

    &-zoom {
      &-enter,
      &-leave {
        display: block;
      }
    }
    &-zoom {
      &-enter,
      &-appear {
        opacity: 0;
        animation-duration: 0.3s;
        animation-fill-mode: both;
        animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
        animation-play-state: paused;
      }
      &-leave {
        animation-duration: 0.3s;
        animation-fill-mode: both;
        animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
        animation-play-state: paused;
      }
      &-enter,
      &-enter-active {
        animation-name: rcToolTipZoomIn;
        animation-play-state: running;
      }
      &-leave,
      &-leave-active {
        animation-name: rcToolTipZoomOut;
        animation-play-state: running;
      }
    }

    &-placement {
      &-top,
      &-topLeft,
      &-topRight {
        padding: 5px 0 9px 0;

        .rc-tooltip-arrow {
          bottom: 4px;
          margin-left: -5px;
          border-width: 5px 5px 0;
          border-top-color: #373737;
        }
      }

      &-top .rc-tooltip-arrow {
        left: 50%;
      }
      &-topLeft .rc-tooltip-arrow {
        left: 15%;
      }
      &-topRight .rc-tooltip-arrow {
        right: 15%;
      }

      &-right,
      &-rightTop,
      &-rightBottom {
        padding: 0 5px 0 9px;

        .rc-tooltip-arrow {
          left: 4px;
          margin-top: -5px;
          border-width: 5px 5px 5px 0;
          border-right-color: #373737;
        }
      }
      &-right .rc-tooltip-arrow {
        top: 50%;
      }
      &-rightTop .rc-tooltip-arrow {
        top: 15%;
        margin-top: 0;
      }
      &-rightBottom {
        padding: 0 5px 0 9px;

        .rc-tooltip-arrow {
          bottom: 15%;
        }
      }
      &-left,
      &-leftTop,
      &-leftBottom {
        padding: 0 9px 0 5px;

        .rc-tooltip-arrow {
          right: 4px;
          margin-top: -5px;
          border-width: 5px 0 5px 5px;
          border-left-color: #373737;
        }
      }
      &-left {
        .rc-tooltip-arrow {
          top: 50%;
        }
      }
      &-leftTop {
        .rc-tooltip-arrow {
          top: 15%;
          margin-top: 0;
        }
      }
      &-leftBottom {
        .rc-tooltip-arrow {
          bottom: 15%;
        }
      }

      &-bottom,
      &-bottomLeft,
      &-bottomRight {
        padding: 9px 0 5px 0;

        .rc-tooltip-arrow {
          top: 4px;
          margin-left: -5px;
          border-width: 0 5px 5px;
          border-bottom-color: #373737;
        }
      }
      &-bottom {
        .rc-tooltip-arrow {
          left: 50%;
        }
      }
      &-bottomLeft {
        .rc-tooltip-arrow {
          left: 15%;
        }
      }
      &-bottomRight {
        .rc-tooltip-arrow {
          right: 15%;
        }
      }
    }

    &-inner {
      padding: 8px 10px;
      color: #fff;
      text-align: left;
      text-decoration: none;
      background-color: #373737;
      border-radius: 6px;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
      min-width: unset;
      min-height: unset;
    }

    &-arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
    }
  }

  @keyframes rcToolTipZoomIn {
    0% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(0, 0);
    }
    100% {
      opacity: 1;
      transform-origin: 50% 50%;
      transform: scale(1, 1);
    }
  }

  @keyframes rcToolTipZoomOut {
    0% {
      opacity: 1;
      transform-origin: 50% 50%;
      transform: scale(1, 1);
    }
    100% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(0, 0);
    }
  }
`;

export default tooltipCss;
